import React, { useEffect, useState } from "react";
import { fetchTradingHistory } from "../../utils";
import Grid from "@origyn-sa/common-ui/src/components/atoms/Grid";
import PageTitle from "@origyn-sa/common-ui/src/components/atoms/PageTitle";
import Table from "@origyn-sa/common-ui/src/components/organisms/Table";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import ActivityStyled from "./Activity.styled";
import { LinearProgress } from "@material-ui/core";

const MarketplaceActivity = () => {
  const [loader, setLoader] = useState<boolean>(true);
  const [click, setClick] = useState(false);
  const [tradingHistory, setTradingHistory] = useState<any[]>([]);

  const refreshTradingHistory = () => {
    setLoader(true);
    fetchTradingHistory()
      .then((data: any) => {
        setTradingHistory(data);
      })
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    refreshTradingHistory();
    const interval = setInterval(() => {
      console.info("fetchTradingHistory");
      refreshTradingHistory();
    }, 8000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  console.log(tradingHistory);

  return (
    <>
      {loader && (
        <LinearProgress
          style={{ position: "fixed", top: 0, left: 0, width: "100%" }}
        />
      )}
      <div style={{ padding: "8px", overflowX: "auto" }}>
        <ActivityStyled>
          <Grid columns={4}>
            <PageTitle
              style={{
                gridColumnStart: 1,
                gridColumnEnd: 2,
              }}
            >
              Activity
            </PageTitle>
            <Button
              className='displayButtonFilter'
              textBtn
              small
              onClick={() => setClick(!click)}
            >
              FILTER
            </Button>
          </Grid>
          <Grid className='gridTitle'>
            <Grid columns={1} style={{ gridColumnStart: 1, gridColumnEnd: 5 }}>
              <Table
                fullWidth
                tableHeadline='Trading history'
                data={tradingHistory.map((item: any) => [
                  { label: item.date, colspan: 1 },
                  { label: item.from, colspan: 1 },
                  { label: item.event, colspan: 1 },
                  { label: item.raw, colspan: 1 },
                  // { label: item.item, colspan: 1 },
                  // { label: item.price, colspan: 1 },
                  // { label: item.to, colspan: 1 },
                ])}
                values={[
                  { label: "Date", colspan: 1 },
                  { label: "From", colspan: 1 },
                  { label: "Event", colspan: 1 },
                  { label: "Raw", colspan: 1 },
                  // { label: "Item", colspan: 1 },
                  // { label: "Price", colspan: 1 },
                  // { label: "To", colspan: 1 },
                ]}
              />
            </Grid>
          </Grid>
        </ActivityStyled>
      </div>
    </>
  );
};

export default MarketplaceActivity;
